import { ExclamationCircleOutlined, MenuOutlined, UserOutlined } from "@ant-design/icons";
import { Alert, Avatar, Button, Col, Dropdown, Layout, Row, Space, Tag, Typography } from "antd";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { AgentStatusColors, urlParams } from "./../../constants/AppConstants";
import { AppContext } from "./../../context/AppContext";
import { useRolesContext } from "./../../context/RolesContext.js";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { checkIsAdmin, OTP_MODAL_EXCLUDE_PATHS } from "../../../src/pages/utils/commonUtils.js";
import useHttp from "../../hooks/useHttp.jsx";
import useLicense from "../../hooks/useLicense.jsx";
import AgentStatusSelect from "../../voice/components/call-screens/AgentStatusSelect.jsx";
import { useVoiceContext } from "../../voice/context/VoiceContext.js";
import { getCurrentFeature, useVoiceIntegId, voiceAgentStatus } from "../../voice/utils/VoiceUtils.js";
import SubAccountsListing from "./../../pages/subAccount/SubAccountsListing.jsx";

import { checkTheCurrentCustomerIsInTrialPeriod, getDaysDifference, getLogoClassByService, InvalidModal } from "../../pages/utils/CommonVessels.js";
import { VoiceAgentStatusSelectMenu } from "../../voice/components/common/VoiceAgentStatusSelectMenu.jsx";
import { useVoiceAgentStatus } from "../../voice/hooks/useVoiceAgentStatus.jsx";
import HToolTip from "../custom/info/HToolTip.jsx";
import { AppsList } from "../../pages/services/AppsList.jsx";
import NotificationPanel from "../notification/NotificationPanel.jsx";
import { useBeams } from "../../context/BeamsContext";
import GlobalSearchBar from "../../global-search/components/GlobalSearchBar.jsx";
import { INCLUDED_FEATURES_IDS } from "../../constants/AppConstants.js";
const { Header } = Layout;
const { Text } = Typography;

const titles = {
  channels: "Channels",
  phone: "Add phone",
  templates: "Templates",
  inbox: "Inbox",
  module: "Campaign Modules",
  sendsms: "Send SMS",
  messages: "Bulk SMS",
  campaigns: "Overview",
  "data-sources": "Data Sources",
  campaign: "Campaign",
  chat: "Chat",
  users: "Users",
  workflow: "Automation",
  campaignOverView: "Detailed Overview",
  general: "Admin Settings",
  callHistory: "Call History",
  callFlow: "Call Flow",
  blockedNumbers: "Blocked Numbers",
  logs: "Message Logs",
  number: "Set Up Twilio Calls"
};

function Headerbar(props) {
  const { toggleSidebar, headerBarHeight, headerBarRef, isGlobalSearchDropDownOpen, setIsGlobalSearchDropDownOpen } = props;
  const [searchParams] = useSearchParams();
  let topBarNeeded = searchParams?.get("topBar");
  let sideBar = searchParams?.get("sideBar");
  const location = useLocation();
  if (
    location.pathname === "/zoho-crm/webhook" ||
    location.pathname === "/voice/dialpad" ||
    location.pathname === "/login" ||
    location.pathname === "/web/signin" ||
    location.pathname === "/web/signup" ||
    location.pathname === "/web/apps"
  ) {
    sideBar = "false";
    topBarNeeded = "false";
  }
  var sideBarFalse = "block";
  if (OTP_MODAL_EXCLUDE_PATHS.includes(location.pathname)) {
    sideBarFalse = "d-none";
  }
  const [title, setTitle] = useState(props.headerTitle);
  const [appProperties] = useContext(AppContext);
  if (navigator.userAgent.includes("HelloSendMobile")) {
    topBarNeeded = "false";
    sideBar = "false";
  }
  const [rolesProperties] = useRolesContext();
  const [userLogo, setUserLogo] = useState();
  const [showAppsList, setShowAppsList] = useState(false);
  const [licensePlanKey, setLicensePlanKey] = useState();
  const [manageSubscriptionUrl, setManageSubscriptionUrl] = useState();
  const isTopBarNeeded = useMemo(() => !topBarNeeded || topBarNeeded !== "false", [topBarNeeded]);
  const navigate = useNavigate();
  const { fetchStripeURL } = useLicense();
  let onBoardingPage = urlParams.get("onBoardingPage");
  const [callProperties, setCallProperties] = useVoiceContext();
  const [conflictPresentInUserLicenseCount, setConflictPresentInUserLicenseCount] = useState(false);
  const [leftAuthModal, setLeftAuthModal] = useState(false);
  const [showOfflineMessageWhileInit, setShowOfflineMessageWhileInit] = useState(false);
  const [restrictAccess, setRestrictAccess] = useState(false);
  const [appsList, setAppsList] = useState({ apps: [], isFetched: false });
  const [leftServiceLogo, setLeftServiceLogo] = useState();
  const [leftServiceName, setLeftServiceName] = useState();
  const { fetchData } = useHttp();
  const { getCurrentVoiceAgentStatus } = useVoiceAgentStatus();

  const voiceIntegId = useVoiceIntegId(appProperties);

  const beams = useBeams();
  const unregisterUser = beams.unregisterUser;
  
  const showServiceErrorIcon = appProperties?.authCRM === false;
  const showSubAccounts = appProperties?.agencyAccount;

  const showGlobalSearch = appProperties?.includedFeatures?.has(INCLUDED_FEATURES_IDS?.GLOBAL_SEARCH);
  
  let path = window.location.pathname;
  const handleLogout = useCallback(() => {
    fetchData(`logout`, "DELETE", null, appProperties).then(async function (response) {
      response = JSON.parse(response);
      if (response?.data?.isValid) {
        if (unregisterUser) {
          await unregisterUser();
        }
        appProperties?.controller?.saveApplicationToken("").then(function () {
          window.location.href = "/logout?" + new URLSearchParams(window.location.search).toString();
        });
      }
    });
  }, [fetchData, appProperties?.osyncId, appProperties?.controller]);

  const fetchAllExistingApps = useCallback(() => {
    if (appsList.isFetched) return;
    fetchData(`accessible/apps`, "GET", null, appProperties).then(function (response) {
      response = JSON.parse(response);
      if (response?.data) {
        setAppsList({ apps: response?.data, isFetched: true });
      }
    });
  }, [fetchData, appProperties?.controller, appsList?.isFetched]);

  const [isVoiceUser, setIsVoiceUser] = useState(false);

  useEffect(() => {
    if (licensePlanKey) {
      if (licensePlanKey === "HS_VOICE" || licensePlanKey === "HS_VOICE_PLUS_MESSAGING") {
        if(callProperties?.savedNumbers?.length < 0) {
        getCurrentVoiceAgentStatus().then((response) => {
          const isVoiceUser = response?.isVoiceUser;
          setIsVoiceUser(isVoiceUser === "true");
        });
        } else {
          setIsVoiceUser(true);
        }
      }
    }
  }, [licensePlanKey, callProperties?.agentStatusValue, callProperties?.savedNumbers?.length]);

  useEffect(() => {
    if (appProperties?.leftServiceDisplayName) {
      setLeftServiceName(appProperties?.leftServiceDisplayName);
      setLeftServiceLogo(getLogoClassByService(appProperties?.leftServiceDisplayName, true));
    }
  }, [appProperties?.leftServiceDisplayName]);

  const loginAreaMenuItemsList = useMemo(
    () =>
      [
        userLogo && {
          label: <CurrentUserProfileDetails userLogo={userLogo} />,
          key: "1",
        },
        {
          type: "divider",
        },
        licensePlanKey &&
          isVoiceUser && {
            label: isVoiceUser ? (
              <VoiceAgentStatusSelectMenu
                setShowOfflineMessageWhileInit={setShowOfflineMessageWhileInit}
                restrictAccess={restrictAccess}
                setRestrictAccess={setRestrictAccess}
                isVoiceUser={isVoiceUser}
                setIsVoiceUser={setIsVoiceUser}
                voiceIntegId={voiceIntegId}
                getCurrentVoiceAgentStatus={getCurrentVoiceAgentStatus}
                voiceAgentStatus={voiceAgentStatus}
                setCallProperties={setCallProperties}
                callProperties={callProperties}
                path={path}
                isFromHeader={true}
              />
            ) : null,
            key: "2",
          },
        { type: "divider" },
        appsList?.apps?.length > 0 && {
          label: (
            <>
              <div className="d-flex align-items-center justify-content-between p-1">
                <div className="d-flex align-items-center cursor-default gap-0">
                  <span
                    className={`${leftServiceLogo} d-flex align-items-center`}
                    style={{ transform: "scale(0.66)", transformOrigin: "left" }}
                  ></span>
                  <span style={{ fontWeight: 500, marginLeft: 0 }}>{leftServiceName}</span>
                </div>

                <Text type="primary" className="cursor-pointer hs-color-violet" onClick={() => setShowAppsList(true)}>
                  Switch Account
                </Text>
              </div>
            </>
          ),
          key: "5",
        },
        appsList?.apps?.length > 0 && { type: "divider" },
        manageSubscriptionUrl && !appProperties?.controller?.manageSubscriptionBtnHide && {
          label: <SubscriptionLabel href={manageSubscriptionUrl} userLogo={userLogo} />,
          key: "3",
        },
        {
          label: (
            <div className="hs-color-red ps-4 ms-2" onClick={handleLogout}>
              Logout
            </div>
          ),
          key: "4",
        },
      ].filter(Boolean),
    [userLogo, licensePlanKey, manageSubscriptionUrl, isVoiceUser, handleLogout, appsList?.apps],
  );

  useEffect(() => {
    const isAdmin = checkIsAdmin(appProperties, rolesProperties);
    if (isAdmin) {
      if (appProperties?.licenseObj?.licenseDetails?.licenseStatus && !navigator.userAgent.includes("HelloSendMobile")) {
        if (appProperties?.licenseHandledBy === "STRIPE") {
          fetchStripeURL(appProperties).then(function (stripeLink) {
            if (stripeLink?.url) {
              setManageSubscriptionUrl(stripeLink?.url);
            }
          });
        } else {
          if (appProperties?.controller?.pricingLink) {
            appProperties.controller.pricingLink(appProperties).then(function (resp) {
              setManageSubscriptionUrl(resp);
            });
          }
        }
      }
    }
  }, [
    appProperties?.controller,
    appProperties?.licenseHandledBy,
    appProperties?.userId,
    appProperties?.licenseObj?.allLicensedUserDetails,
    rolesProperties,
    fetchStripeURL,
  ]);

  useEffect(() => {
    if (appProperties?.licenseObj?.conflictPresentInUserLicenseCount) {
      // The below commented code is not needed but let it be for the time being and can be removed later
      // let currentUserHasUserRole = isCurrentUserHasUserRolePermission(appProperties);
      // let isTrialCustomer = checkTheCurrentCustomerIsInTrialPeriod(appProperties);
      // if (!currentUserHasUserRole && !isTrialCustomer) {
      //   setConflictPresentInUserLicenseCount(appProperties?.licenseObj?.conflictPresentInUserLicenseCount === "true");
      // }
      setConflictPresentInUserLicenseCount(appProperties?.licenseObj?.conflictPresentInUserLicenseCount === "true");
    }
  }, [appProperties?.licenseObj]);

  useEffect(() => {
    if (appProperties?.headerTitleName) {
      setTitle(appProperties?.headerTitleName);
    }
  }, [appProperties?.headerTitleName]);

  useEffect(() => {
    if (appProperties?.licenseObj?.licenseDetails?.licensePlanKey) {
      setLicensePlanKey(appProperties?.licenseObj?.licenseDetails?.licensePlanKey);
    }
  }, [appProperties?.licenseObj?.licenseDetails?.licensePlanKey]);

  useEffect(() => {
    appProperties.headerTitleName = "";
    setTitle(titles[props.headerTitle] || props.headerTitle);
    let userLogoText = appProperties.userLogo || appProperties?.userName?.charAt?.(0)?.toUpperCase() || appProperties?.currentUser?.email?.charAt?.(0)?.toUpperCase();    
    setUserLogo(userLogoText);
  }, [props.headerTitle, appProperties.userLogo, appProperties.userName, location.pathname, appProperties?.controller]);

  if (!isTopBarNeeded) {
    return <></>;
  }

  return (
    <Header
      ref={headerBarRef}
      className={`allPageContainer p-0 hs-border-dark-grey-bottom ${sideBarFalse}`}
      style={{
        height: conflictPresentInUserLicenseCount ? 100 : headerBarHeight,
        zIndex: isGlobalSearchDropDownOpen ? "auto" : 3,
        lineHeight: "60px",
        backgroundColor: sideBar === "false" ? "transparent" : "#fff",
        paddingLeft: "0rem",
      }}
    >
      <div className="w-100 d-flex align-items-center flex-nowrap">
        <div className="d-flex align-items-center flex-shrink-0 overflow-hidden">
          {location.pathname.includes("/settings/") ? (
            <Button
              className="d-lg-none px-1 mx-2"
              type="text"
              icon={<div className="actionIconsSprite back-icon" />}
              onClick={() => {
                navigate(-1);
              }}
            />
          ) : (
            <Button
              className="d-lg-none mx-2 px-1"
              type="text"
              icon={<MenuOutlined />}
              onClick={() => {
                toggleSidebar();
              }}
            ></Button>
          )}
          <div className="w-100">
            <h1
              className="my-3 ms-1 align-items-center d-flex"
              style={{
                textTransform: "capitalize",
                color: "#111827",
                fontWeight: 700,
                fontSize: 20,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {typeof title === "string" ? (
                <HeaderBarSubTitle onBoardingPage={onBoardingPage} isBeta={false} headerTitle={title} />
              ) : (
                <HeaderBarSubTitle onBoardingPage={onBoardingPage} isBeta={title.isBeta ? title.isBeta : false} headerTitle={title.label} />
              )}
            </h1>
          </div>
        </div>

        {showGlobalSearch && (
          <div className="d-flex justify-content-center flex-grow-1 min-w-0">
            <GlobalSearchBar isGlobalSearchDropDownOpen={isGlobalSearchDropDownOpen} setIsGlobalSearchDropDownOpen={setIsGlobalSearchDropDownOpen} />
          </div>
        )}

        <div className="ms-auto d-flex align-items-center flex-shrink-0 overflow-hidden">
          {showServiceErrorIcon && (
            <div className="pe-2">
              <div className="w-100">
                <HToolTip title={appProperties?.authContent}>
                  <div
                    className="d-flex align-items-center cursor-pointer justify-content-center"
                    onClick={() => {
                      setLeftAuthModal(true);
                    }}
                  >
                    <div className="actionIconsSprite service-warning-icon" />
                    <Text ellipsis className="hs-color-warning d-none d-md-block">
                      Connect {appProperties?.leftServiceDisplayName || "Service"}
                    </Text>
                  </div>
                  <InvalidModal open={leftAuthModal} setOpen={setLeftAuthModal} closable={true} />
                </HToolTip>
              </div>
            </div>
          )}

          {showSubAccounts && (
            <div className="d-none d-block d-md-flex">
              <SubAccountsListing selectComponentWidth={"140px"} selectComponentHeight={40} />
            </div>
          )}

          <TrialDaysLabel appProperties={appProperties} />

          <div className="ps-1">
            <Button
              data-sleek
              data-badge-changelog
              className="announcementHover d-flex align-items-center justify-content-center border-0 shadow-0"
              style={{ boxShadow: "none", padding: "4px 4px" }}
            >
              <div className="actionIconsSprite announcement"></div>
              <span className="d-none d-md-block">What's New</span>
            </Button>
          </div>

          <div className="d-flex align-items-center ps-2">
            <NotificationPanel />
          </div>

          <div className="d-flex justify-content-end h-100 flex-shrink-0 ps-3">
            <Space className="d-flex justify-content-end h-100 w-100">
              <>
                <Dropdown
                  onOpenChange={(open) => open && fetchAllExistingApps()}
                  menu={{ items: loginAreaMenuItemsList }}
                  trigger={["click"]}
                  rootClassName="profile-dropdown"
                >
                  <Button
                    data-cy="profile-avatar-btn-in-header"
                    className="ps-0 border-none boxShadowRemove d-flex justify-content-center h-100 w-100"
                  >
                    <Space className="profileAvatarBg h-100 w-100">
                      <Avatar
                        style={{
                          backgroundColor: "#d5fce3",
                          color: "black",
                          verticalAlign: "middle",
                          border: "1px solid #d5fce3",
                        }}
                        size="large"
                        className="manageSubscription"
                        src={userLogo}
                        border="light"
                      >
                        {userLogo || <UserOutlined />}
                      </Avatar>
                      <div
                        style={{
                          position: "absolute",
                          left: "55%",
                          transform: "translateX(-50%)",
                          width: "13px",
                          height: "13px",
                          borderRadius: "50%",
                          backgroundColor: AgentStatusColors[callProperties?.agentStatusValue],
                          border: "2px solid white",
                          top: "63%",
                        }}
                      ></div>
                      {loginAreaMenuItemsList?.items?.length > 0 ? <div className="actionIconsSprite headerDropDownIcon" /> : null}
                    </Space>
                  </Button>
                </Dropdown>
              </>
            </Space>
          </div>
        </div>
      </div>
      {conflictPresentInUserLicenseCount ? (
        <Row className="w-100">
          <Col className="w-100">
            <Alert
              message={
                <>
                  <ExclamationCircleOutlined className="pe-2" style={{ fontSize: "1rem", color: "#FF9800" }} />{" "}
                  <span className="hs-fw-500 hs-fs-12" style={{ color: "#FF9800" }}>
                    {" "}
                    The active user count exceeds the purchased limit. The subscription will be updated accordingly in a few days.
                  </span>
                </>
              }
              type="warning"
              style={{
                borderRadius: 0,
                border: 0,
                background: "#FFF5E3",
              }}
            />
          </Col>
        </Row>
      ) : null}
      {showAppsList && (
        <AppsList
          oncancel={() => setShowAppsList(false)}
          apps={appsList?.apps}
          appProperties={appProperties}
          isWebsiteLogin={true}
          showSignInWithAnotherEmail={false}
        />
      )}
    </Header>
  );
}

export default Headerbar;

const TrialDaysLabel = ({ appProperties }) => {
  const [daysLeft, setDaysLeft] = useState(null);

  useEffect(() => {
    try {
      if (!checkTheCurrentCustomerIsInTrialPeriod(appProperties)) return;
      const licenseDetails = appProperties?.licenseObj?.licenseDetails;
      const startDate = new Date(licenseDetails?.trialStartDate || licenseDetails?.createdTime);
      const trialDays = licenseDetails?.trialDays || 3;
      const endDate = new Date(startDate.getTime() + trialDays * 24 * 60 * 60 * 1000);
      const remaining = Math.max(0, Math.floor(getDaysDifference(endDate, new Date())));
      setDaysLeft(remaining);
    } catch {}
  }, [appProperties?.osyncId, appProperties?.licenseObj?.licenseDetails?.licenseStatus]);

  if (daysLeft === null) return null;

  return (
    <div className="d-none d-md-flex align-items-center ps-1">
      <Tag color="orange" className="hs-fw-500 hs-border-12">
        {daysLeft} day{daysLeft !== 1 ? "s" : ""} left in trial
      </Tag>
    </div>
  );
};

export const SubscriptionLabel = (props) => {
  let { href } = props;

  const [licenseStatus, setLicenseStatus] = useState();
  const [appProperties] = useContext(AppContext);
  const currentUserObj = appProperties?.licenseObj?.allLicensedUserDetails?.find((user) => user?.remoteUserId === appProperties?.userId);
  const roleId = currentUserObj?.roleId?.toString();
  const userRoleKey = Object.entries(appProperties?.rolesBasedObject || {}).find(([_, value]) => value === "USER")?.[0];
  const [showManageSubscription, setShowManageSubscription] = useState(true);

  useEffect(() => {
    const controller = appProperties?.controller;
    if (!controller?.isCreditAccessible) return;

    controller
      .isCreditAccessible()
      .then((isCreditAccessible) => setShowManageSubscription(isCreditAccessible))
      .catch(() => setShowManageSubscription(true));
  }, [appProperties?.controller]);

  useEffect(() => {
    if (appProperties?.licenseObj?.licenseDetails?.licenseStatus && appProperties?.licenseStatusEnum) {
      const licenseStatusName = appProperties?.licenseStatusEnum[appProperties?.licenseObj?.licenseDetails?.licenseStatus];
      setLicenseStatus(licenseStatusName);
    }
  }, [appProperties?.licenseObj?.licenseDetails?.licenseStatus]);

  return (
    <div className="pt-1 pb-1 d-flex flex-column ps-1">
      <div className="d-flex flex-row justify-content-between align-items-center pb-2 cursor-default">
        <div className="d-flex flex-row align-items-center ">
          <div className="actionIconsSprite current-plan-header-icon" />
          <div className="hs-fs-13 hs-fw-500 hs-ps-1-5">Current Plan </div>
        </div>
        <div className="">
          <div className="hs-bg-light-violet hs-border-1-25-rem hs-fs-11 hs-color-violet hs-fw-500 p-2 px-3">{licenseStatus}</div>
        </div>
      </div>
      {roleId !== userRoleKey && showManageSubscription && !appProperties?.controller?.manageSubscriptionBtnHide && (
        <a target="_blank" className="custom-anchor-blue hs-fs-13-6-px ps-4 py-1 ms-1 manage-sub-container" rel="noopener noreferrer" href={href}>
          Manage Subscription
        </a>
      )}
    </div>
  );
};
export const CurrentUserProfileDetails = (props) => {
  let { userLogo } = props;

  const [appProperties] = useContext(AppContext);
  return (
    <>
      <div className="d-flex flow-row cursor-default">
        <div className="d-flex align-items-center">
          <Avatar
            style={{
              backgroundColor: "#d5fce3",
              color: "black",
              verticalAlign: "middle",
              border: "1px solid #d5fce3",
              width: "52px",
              height: "54px",
              borderRadius: "50px",
            }}
            size="large"
            className="manageSubscription"
            src={userLogo}
            border="light"
          >
            {userLogo || <UserOutlined />}
          </Avatar>
        </div>
        <div className="d-flex flex-column ms-3">
          <span className="hs-fs-15 hs-fw-600 pb-1">{appProperties?.userName}</span>
          <span className="pb-1">{appProperties?.currentUser?.email ? decodeURIComponent(appProperties?.currentUser?.email) : ""}</span>
        </div>
      </div>
    </>
  );
};
export const VoiceAgentStatusDetails = (props) => {
  let { licensePlanKey, isVoiceUser } = props;

  return (
    <>
      {isVoiceUser ? (
        <>
          <div className="d-flex flex-row pt-1 pb-1 justify-content-between profile-status-container">
            <div className="d-flex align-items-center cursor-default">
              <div className="call-action-icons phoneIcon header-call" />
              <span className="hs-fs-14 hs-fw-500 ps-1">Phone</span>
            </div>

            <div onClick={(e) => e.stopPropagation()}>
              <AgentStatusSelect classNameProps="agentStatusForWhiteBackground" expandIcon={"statusOpenArrow mb-2"} />
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
export const HeaderBarSubTitle = (props) => {
  let { onBoardingPage, isBeta, headerTitle } = props;

  return (
    <>
      <div className="d-flex flex-row align-items-center">
        <div className={`${onBoardingPage ? "ps-5" : "ps-4"}`}>{headerTitle}</div>
        {isBeta ? (
          <div className="ps-lg-2 pb-lg-1">
            {" "}
            <Tag bordered={false} color="#EEF2FF" className="hs-border-1-25-rem ">
              <span className="hs-color-blue-1">Beta</span>
            </Tag>
          </div>
        ) : null}
      </div>
    </>
  );
};
